import { HostListener, Component } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Routes, RouterModule, Router } from '@angular/router';
import * as ngswal from "sweetalert";
import * as Highcharts from 'highcharts';
import { GlobalConstants } from '../../common/global-constants';
import { TTPModel } from './ttp-model';
import { customfunctions } from '../../common/customfunctions';
import { ApiMethod } from '../../apimethods/api-method';
declare var $;

@Component({
  selector: 'ttp-dashboard.component',
  templateUrl: './ttp-dashboard.component.html',
  styleUrls: ['./ttp-dashboard.component.css']
})

export class TTPDashboardComponent {
  modelData: TTPModel = new TTPModel();
  public TTPTab: boolean = GlobalConstants.CheckMetadataView('TTPTab');
  public PMWiseTab: boolean = GlobalConstants.CheckMetadataView('PMWiseTab');
  public TTPIssueTab: boolean = GlobalConstants.CheckMetadataView('TTPIssueTab');
  public IssPMWiseTab: boolean = GlobalConstants.CheckMetadataView('IssPMWiseTab');
  public TTPFeedbackTab: boolean = GlobalConstants.CheckMetadataView('TTPFeedbackTab');
  public TTPWIPTab: boolean = GlobalConstants.CheckMetadataView('TTPWIPTab');
  public CurrentYear = "";
  WIPCt = ''; HoldCount = ''; Overdue = '';

  constructor(private router: Router, http: HttpClient) {
  }

  ngOnInit(): void {
    var now = new Date();
    this.modelData.WIPSummary = null;
    this.CurrentYear = now.getFullYear().toString();
    this.EnableMonthList();
    this.LoadChartTTPSummary(now.getFullYear(), now.getMonth());
    this.LoadChartIssueSummary(now.getFullYear(), now.getMonth());
    this.LoadChartFeedback(now.getFullYear(), now.getMonth());
    this.LoadChartWIPSummary(now.getFullYear(), now.getMonth());
    $('#liPMWiseTab').click(function () {
      $('#MonthList').removeClass("DisableDiv");
    });
  }
  highchartsArtPM: typeof Highcharts = Highcharts; chartOptionsArtPM;
  highchartsArt: typeof Highcharts = Highcharts; chartOptionsArt;
  highchartsIss: typeof Highcharts = Highcharts; chartOptionsIss;
  highchartsIssPM: typeof Highcharts = Highcharts; chartOptionsIssPM;
  highchartsFeed: typeof Highcharts = Highcharts; chartOptionsFeed;
  highchartsWIP: typeof Highcharts = Highcharts; chartOptionsWIP;
  EnableMonthList() {
    $('#MonthList').removeClass("DisableDiv");
    $('#yearList').removeClass("DisableDiv");
    $('#dateFilter').addClass("DisableDiv");
    if ($('#tabTTP').hasClass("active") || $('#tabTTPIssue').hasClass("active") || $('#tabWIPArticle').hasClass("active")) {
      $('#MonthList').addClass("DisableDiv");
      $('#dateFilter').addClass("DisableDiv");
    }
  }
  getFiltered(YearVal, MonthVal) {
    if (YearVal == 0) { YearVal = this.CurrentYear; }
    else {
      $('.btn.clsMargin.active').removeClass("active");
      $('#Btn' + YearVal).addClass("active");
    }
    $('.btn.month.active').removeClass("active");
    var btnName = GlobalConstants.month_names[MonthVal - 1];
    $('#Btn' + btnName).addClass("active");
    this.CurrentYear = YearVal;
    this.LoadChartTTPSummary(YearVal, MonthVal);
    this.LoadChartIssueSummary(YearVal, MonthVal);
    this.LoadChartFeedback(YearVal, MonthVal);
    this.LoadChartWIPSummary(YearVal, MonthVal);
  }
  LoadChartFeedback(yearVal, monthVal) {
    $("#LoadingImage").show();
    var dashboardPostData = {
      LoginID: localStorage.aLoginID,
      PublisherID: "0",
      FilterType: "",
      Month: monthVal,
      Year: yearVal
    }
    ApiMethod.postMethod('/dash/GetTTPFeedbackChart', dashboardPostData).subscribe(
      resonse => {
        try {
          let aitemList = resonse.aitemList;
          let chartComm: any = []; let chartCopyediting: any = []; let chartPE_Management: any = []; let chartTypesetting: any = []; let chartTechnology: any = []; let chartGeneral: any = []; let chartKudos: any = []; let chartNotVendorerror: any = []; let chartTotal: any = []; let monthList: any = [];
          let chartSeriesList: any = [];

          $(aitemList).each(function (index, val) {
            chartComm.push({ name: val.TTPMonthYear, y: val.Communication });
            chartCopyediting.push({ name: val.TTPMonthYear, y: val.Copyediting });
            chartPE_Management.push({ name: val.TTPMonthYear, y: val.PE_Management });
            chartTypesetting.push({ name: val.TTPMonthYear, y: val.Typesetting });
            chartTechnology.push({ name: val.TTPMonthYear, y: val.Technology });
            chartGeneral.push({ name: val.TTPMonthYear, y: val.General });
            chartKudos.push({ name: val.TTPMonthYear, y: val.Kudos });
            chartNotVendorerror.push({ name: val.TTPMonthYear, y: val.NotVendorerror });
            chartTotal.push({ name: val.TTPMonthYear, y: val.Total });
            monthList.push(val.TTPMonthYear);
          });
          chartSeriesList.push({
            name: 'Communication', data: chartComm, color: '#' + (Math.random() * 0xEEEEEE << 0).toString(16),
            dataLabels: {
              enabled: true,
              color: '#000',
              format: '{point.y}'
            }
          });
          chartSeriesList.push({
            name: 'Copyediting', data: chartCopyediting, color: '#' + (Math.random() * 0xEEEEEE << 0).toString(16),
            dataLabels: {
              enabled: true,
              color: '#000',
              format: '{point.y}'
            }
          });
          chartSeriesList.push({
            name: 'PE Management', data: chartPE_Management, color: '#' + (Math.random() * 0xEEEEEE << 0).toString(16),
            dataLabels: {
              enabled: true,
              color: '#000',
              format: '{point.y}'
            }
          });
          chartSeriesList.push({
            name: 'Typesetting', data: chartTypesetting, color: '#' + (Math.random() * 0xEEEEEE << 0).toString(16),
            dataLabels: {
              enabled: true,
              color: '#000',
              format: '{point.y}'
            }
          });
          chartSeriesList.push({
            name: 'Technology', data: chartTechnology, color: '#' + (Math.random() * 0xEEEEEE << 0).toString(16),
            dataLabels: {
              enabled: true,
              color: '#000',
              format: '{point.y}'
            }
          });
          chartSeriesList.push({
            name: 'General', data: chartGeneral, color: '#' + (Math.random() * 0xEEEEEE << 0).toString(16),
            dataLabels: {
              enabled: true,
              color: '#000',
              format: '{point.y}'
            }
          });
          chartSeriesList.push({
            name: 'Kudos', data: chartKudos, color: '#' + (Math.random() * 0xEEEEEE << 0).toString(16),
            dataLabels: {
              enabled: true,
              color: '#000',
              format: '{point.y}'
            }
          });
          chartSeriesList.push({
            name: 'Not a Vendor Error', data: chartNotVendorerror, color: '#' + (Math.random() * 0xEEEEEE << 0).toString(16),
            dataLabels: {
              enabled: true,
              color: '#000',
              format: '{point.y}'
            }
          });
          chartSeriesList.push({
            name: 'Total', data: chartTotal, color: '#' + (Math.random() * 0xEEEEEE << 0).toString(16),
            dataLabels: {
              enabled: true,
              color: '#000',
              format: '{point.y}'
            }
          });
          this.LoadChartDataFeedBack(chartSeriesList, monthList);
        } catch (e) {
          ngswal("Warning !", e, "warning");
        }
        $("#LoadingImage").hide();
      },
      error => {
        console.log(error);
        $("#LoadingImage").hide();
      });
  }
  LoadWIPSummary() {
    var dashboardPostSum = {
      LoginID: localStorage.aLoginID,
      PublisherID: "0",
      FilterType: "",
      FromDate: Date.now,
      ToDate: Date.now
    }
    ApiMethod.postMethod('/dash/GetTTPWIPSummChart', dashboardPostSum).subscribe(
      resonse => {
        try {
          //TotalCount	TotalWIP	FPWIP	CorWIP	WithAuthor	WithPM	TotalHold	FPHold	AUHold
          //2251	1552	558	398	430	596	269	69	199
          let aitemList = resonse.aitemList;
          this.modelData.WIPSummary = JSON.parse(JSON.stringify(resonse.aitemList));

          this.WIPCt = aitemList[0].WIP;
          this.HoldCount = aitemList[0].Hold;
          this.Overdue = aitemList[0].Overdue;
          
        } catch (e) {
          ngswal("Warning !", e, "warning");
        }
        $("#LoadingImage").hide();
      },
      error => {
        console.log(error);
        $("#LoadingImage").hide();
      });
  }
  LoadChartWIPSummary(yearVal, monthVal) {
    $("#LoadingImage").show();
    this.LoadWIPSummary();
    var FilterType = "Summary";
    var dashboardPostData = {
      LoginID: localStorage.aLoginID,
      PublisherID: "0",
      FilterType: FilterType,
      Month: monthVal,
      Year: yearVal
    }
    ApiMethod.postMethod('/dash/GetTTPWIPChart', dashboardPostData).subscribe(
      resonse => {
        try {
          let aitemList = resonse.aitemList;

          let chartDataTotalWIP: any = []; let chartDataWIP: any = []; let monthList: any = [];
          let chartSeriesList: any = [];

          $(aitemList).each(function (index, val) {
            chartDataTotalWIP.push({ y: val.TotalCount, name: val.TTPMonthYear });
            chartDataWIP.push({ y: val.TotalPublished, name: val.TTPMonthYear });
            monthList.push(val.TTPMonthYear);
          });
          chartSeriesList.push({
            name: 'Received Article Count', data: chartDataTotalWIP, color: '#' + (Math.random() * 0xEEEEEE << 0).toString(16),
            dataLabels: {
              enabled: true,
              color: '#000',
              format: '{point.y}'
            }
          });
          chartSeriesList.push({
            name: 'Published Article Count', data: chartDataWIP, color: '#' + (Math.random() * 0xEEEEEE << 0).toString(16),
            dataLabels: {
              enabled: true,
              color: '#000',
              format: '{point.y}'
            }
          });
          this.LoadChartDataWIPSummary(chartSeriesList, monthList);
        } catch (e) {
          ngswal("Warning !", e, "warning");
        }
        $("#LoadingImage").hide();
      },
      error => {
        console.log(error);
        $("#LoadingImage").hide();
      });
  }

  LoadChartIssueSummary(yearVal, monthVal) {
    $("#LoadingImage").show();
    var FilterType = "IssueSummary";
    var dashboardPostData = {
      LoginID: localStorage.aLoginID,
      PublisherID: "0",
      FilterType: FilterType,
      Month: monthVal,
      Year: yearVal
    }
    ApiMethod.postMethod('/dash/GetTTPIssuesChart', dashboardPostData).subscribe(
      resonse => {
        try {
          let aitemList = resonse.aitemList;

          let chartDataTotal: any = []; let chartDataPosted: any = []; let chartDataOnTime: any = []; let monthList: any = [];
          let chartSeriesList: any = [];

          $(aitemList).each(function (index, val) {
            chartDataTotal.push({ y: val.TotalNoIssue, name: val.TTPMonthYear });
            chartDataPosted.push({ y: val.Posted, name: val.TTPMonthYear });
            chartDataOnTime.push({ y: val.OnTime, name: val.TTPMonthYear });
            monthList.push(val.TTPMonthYear);
          });
          chartSeriesList.push({
            name: 'Total No of Issues', data: chartDataTotal, color: '#' + (Math.random() * 0xEEEEEE << 0).toString(16),
            dataLabels: {
              enabled: true,
              color: '#000',
              format: '{point.y}'
            }
          });
          chartSeriesList.push({
            name: 'Total no of posted Issues', data: chartDataPosted, color: '#' + (Math.random() * 0xEEEEEE << 0).toString(16),
            dataLabels: {
              enabled: true,
              color: '#000',
              format: '{point.y}'
            }
          });
          chartSeriesList.push({
            name: 'No of Issues posted Ontime', data: chartDataOnTime, color: '#' + (Math.random() * 0xEEEEEE << 0).toString(16),
            dataLabels: {
              enabled: true,
              color: '#000',
              format: '{point.y}'
            }
          });
          this.LoadChartDataIssueSummary(chartSeriesList, monthList);
        } catch (e) {
          ngswal("Warning !", e, "warning");
        }
        $("#LoadingImage").hide();
      },
      error => {
        console.log(error);
        $("#LoadingImage").hide();
      });

    FilterType = "IssueSummaryPMWise";
    var dashboardPostData = {
      LoginID: localStorage.aLoginID,
      PublisherID: "0",
      FilterType: FilterType,
      Month: monthVal,
      Year: yearVal
    }
    ApiMethod.postMethod('/dash/GetTTPIssuesChart', dashboardPostData).subscribe(
      resonse => {
        try {
          let aitemList = resonse.aitemList;

          let chartDataTotal: any = []; let chartDataPosted: any = []; let chartDataOnTime: any = []; let monthList: any = [];
          let chartSeriesList: any = [];

          $(aitemList).each(function (index, val) {
            chartDataOnTime.push({
              y: val.AchivedPer, name: val.PMName
            });
            monthList.push(val.PMName);
          });
          chartSeriesList.push({
            name: 'Percentage of posted Issues', data: chartDataOnTime, color: '#' + (Math.random() * 0xEEEEEE << 0).toString(16),
            dataLabels: {
              enabled: true,
              color: '#000',
              format: '{point.y}'
            }
          });
          this.LoadChartDataIssuePMWise(chartSeriesList, monthList);
        } catch (e) {
          ngswal("Warning !", e, "warning");
        }
        $("#LoadingImage").hide();
      },
      error => {
        console.log(error);
        $("#LoadingImage").hide();
      });

  }

  LoadChartTTPSummary(yearVal, monthVal) {
    $("#LoadingImage").show();
    var FilterType = "TTPSummary";
    var dashboardPostData = {
      LoginID: localStorage.aLoginID,
      PublisherID: "0",
      FilterType: FilterType,
      Month: monthVal,
      Year: yearVal
    }
    ApiMethod.postMethod('/dash/GetTTPArticlesChart', dashboardPostData).subscribe(
      resonse => {
        try {
          let aitemList = resonse.aitemList;

          let chartDataOA: any = []; let chartDataNoOA: any = []; let chartDataTarget: any = []; let monthList: any = [];
          let chartSeriesList: any = [];

          $(aitemList).each(function (index, val) {
            chartDataOA.push({ y: val.OATTP, name: val.TTPMonthYear });
            chartDataTarget.push({ y: val.Target, name: val.TTPMonthYear });
            chartDataNoOA.push({ y: val.NonOATTP, name: val.TTPMonthYear });

            monthList.push(val.TTPMonthYear);
          });
          chartSeriesList.push({
            name: 'OA', data: chartDataOA, color: '#' + (Math.random() * 0xEEEEEE << 0).toString(16),
            dataLabels: {
              enabled: true,
              color: '#000',
              format: '{point.y}'
            }
          });
          chartSeriesList.push({
            name: 'Non OA', data: chartDataNoOA, color: '#' + (Math.random() * 0xEEEEEE << 0).toString(16),
            dataLabels: {
              enabled: true,
              color: '#000',
              format: '{point.y}'
            }
          });
          chartSeriesList.push({
            name: 'Target', data: chartDataTarget, color: '#' + (Math.random() * 0xEEEEEE << 0).toString(16),
            dataLabels: {
              enabled: true,
              color: '#000',
              format: '{point.y}'
            }
          });
          this.LoadChartDataTTPSummary(chartSeriesList, monthList);
        } catch (e) {
          ngswal("Warning !", e, "warning");
        }
        $("#LoadingImage").hide();
      },
      error => {
        console.log(error);
        $("#LoadingImage").hide();
      });

    var FilterType = "TTPSummaryPMWise";
    var dashboardPostData = {
      LoginID: localStorage.aLoginID,
      PublisherID: "0",
      FilterType: FilterType,
      Month: monthVal,
      Year: yearVal
    }
    ApiMethod.postMethod('/dash/GetTTPArticlesChart', dashboardPostData).subscribe(
      resonse => {
        try {
          let aitemList = resonse.aitemList;
          let chartDataTotal: any = []; let NameList: any = [];
          let chartSeriesList: any = [];
          $(aitemList).each(function (index, val) {
            chartDataTotal.push({ y: val.OverAllTTP, name: val.PMName });
            NameList.push(val.PMName);
          });
          chartSeriesList.push({
            name: 'TTP Range(Days)', data: chartDataTotal, color: '#' + (Math.random() * 0xEEEEEE << 0).toString(16),
            dataLabels: {
              enabled: true,
              color: '#000',
              format: '{point.y}'
            }
          });
          this.LoadChartDataTTPPMWise(chartSeriesList, NameList);

        } catch (e) {
          ngswal("Warning !", e, "warning");
        }
        $("#LoadingImage").hide();
      },
      error => {
        console.log(error);
        $("#LoadingImage").hide();
      });


  }
  LoadChartDataIssueSummary(chartSeriesList, chartDataCol1): void {
    try {
      //Column Chart
      highchartsIss: typeof Highcharts; this.chartOptionsIss;
      this.highchartsIss = Highcharts;
      this.chartOptionsIss = {
        chart: {
          type: 'column',
        },
        title: {
          text: 'TTP Issue Summary'
        },
        xAxis: {
          title: { Text: 'Month' },
          categories: chartDataCol1,
          crosshair: false,
        },
        yAxis: {
          title: { text: 'No of Issue' },
          min: 0,
          max: 200,
        },
        style: {
          fontFamily: 'Poppins, Arial, sans-serif'  // Specify a readable font family
        },
        legend: {
          reversed: true,
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'middle',
          borderWidth: 0,
          showInLegend: false
        },
        tooltip: {
          headerFormat: '<span style = "font-size:10px">{category}</span><table>',
          pointFormat: '<tr><td style = "color:{series.color};padding:0">{series.name}: </td>' +
            '<td style = "padding:0"><b>{point.y}</b></td></tr>', footerFormat: '</table>', shared: true, useHTML: true
        },
        series: chartSeriesList
      };
    } catch (e) {
      ngswal("Warning !", e, "warning");
      $("#LoadingImage").hide();
    }

  }
  LoadChartDataIssuePMWise(chartSeriesList, chartDataCol1): void {
    try {
      //Column Chart
      highchartsIssPM: typeof Highcharts; this.chartOptionsIssPM;
      this.highchartsIssPM = Highcharts;
      this.chartOptionsIssPM = {
        chart: {
          type: 'bar',
        },
        title: {
          text: 'Issue Posted Percentage'
        },
        yAxis: {
          title: { text: 'Sum of Average' },
          min: 0,
          max: 100,
        },
        xAxis: {
          title: { Text: 'Project Manager' },
          categories: chartDataCol1,
          crosshair: false,
        },
        style: {
          fontFamily: 'Poppins, Arial, sans-serif'  // Specify a readable font family
        },
        legend: {
          reversed: true,
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'middle',
          borderWidth: 0,
          showInLegend: false
        },
        tooltip: {
          headerFormat: '<span style = "font-size:10px">{category}</span><table>',
          pointFormat: '<tr><td style = "color:{series.color};padding:0">{series.name}: </td>' +
            '<td style = "padding:0"><b>{point.y}</b></td></tr>', footerFormat: '</table>', shared: true, useHTML: true
        },
        series: chartSeriesList
      };
    } catch (e) {
      ngswal("Warning !", e, "warning");
      $("#LoadingImage").hide();
    }

  }



  LoadChartDataFeedBack(chartSeriesList, chartDataCol1): void {
    try {
      //Column Chart
      highchartsFeed: typeof Highcharts; this.chartOptionsFeed;
      this.highchartsFeed = Highcharts;
      this.chartOptionsFeed = {
        chart: {
          type: 'column',
        },
        title: {
          text: 'Feedbacks'
        },
        yAxis: {
          title: { text: 'Sum of Feedbacks' },
          min: 0,
          max: 50,
        },
        xAxis: {
          title: { Text: 'Month' },
          categories: chartDataCol1,
          crosshair: false,
        },
        style: {
          fontFamily: 'Poppins, Arial, sans-serif'  // Specify a readable font family
        },
        legend: {
          reversed: true,
          layout: 'Vertical',
          align: 'right',
          verticalAlign: 'middle',
          borderWidth: 0,
          showInLegend: false
        },
        tooltip: {
          headerFormat: '<span style = "font-size:10px">{category}</span><table>',
          pointFormat: '<tr><td style = "color:{series.color};padding:0">{series.name}: </td>' +
            '<td style = "padding:0"><b>{point.y}</b></td></tr>', footerFormat: '</table>', shared: true, useHTML: true
        },
        series: chartSeriesList
      };
    } catch (e) {
      ngswal("Warning !", e, "warning");
      $("#LoadingImage").hide();
    }

  }


  LoadChartDataTTPPMWise(chartSeriesList, chartDataCol1): void {
    try {
      //Column Chart
      this.chartOptionsArtPM;
      this.highchartsArtPM = Highcharts;
      this.chartOptionsArtPM = {
        chart: {
          type: 'column',
        },
        title: {
          text: 'TTP Summary - Project Manager'
        },
        xAxis: {
          title: {
            text: 'Project Manager'
          },
          categories: chartDataCol1,
          crosshair: false,
        },
        yAxis: {
          title: {
            text: 'TTP Range(Days)'
          },
          min: 5,
          max: 50,
        },
        style: {
          fontFamily: 'Poppins, Arial, sans-serif'  // Specify a readable font family
        },
        legend: {
          reversed: true,
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'middle',
          borderWidth: 0,
          showInLegend: false
        },
        tooltip: {
          headerFormat: '<span style = "font-size:10px">{category}</span><table>',
          pointFormat: '<tr><td style = "color:{series.color};padding:0">{series.name}: </td>' +
            '<td style = "padding:0"><b>{point.y}</b></td></tr>', footerFormat: '</table>', shared: true, useHTML: true
        },
        series: chartSeriesList
      };
    } catch (e) {
      ngswal("Warning !", e, "warning");
      $("#LoadingImage").hide();
    }
  }
  LoadChartDataWIPSummary(chartSeriesList, chartDataCol1): void {
    try {
      //Column Chart
      highchartsWIP: typeof Highcharts; this.chartOptionsWIP;
      this.highchartsWIP = Highcharts;
      this.chartOptionsWIP = {
        chart: {
          type: 'spline',
        },
        title: {
          text: 'WIP and Published'
        },
        xAxis: {
          title: { Text: 'Month' },
          categories: chartDataCol1,
          crosshair: false,
        },
        yAxis: {
          title: { text: 'Article Count' },
          min: 0,
          max: 2800,
        },
        style: {
          fontFamily: 'Poppins, Arial, sans-serif'  // Specify a readable font family
        },
        legend: {
          reversed: true,
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'middle',
          borderWidth: 0,
          showInLegend: false
        },
        tooltip: {
          headerFormat: '<span style = "font-size:10px">{category}</span><table>',
          pointFormat: '<tr><td style = "color:{series.color};padding:0">{series.name}: </td>' +
            '<td style = "padding:0"><b>{point.y}</b></td></tr>', footerFormat: '</table>', shared: true, useHTML: true
        },
        series: chartSeriesList
      };
    } catch (e) {
      ngswal("Warning !", e, "warning");
      $("#LoadingImage").hide();
    }
  }
  LoadChartDataTTPSummary(chartSeriesList, chartDataCol1): void {
    try {
      //Column Chart
      highchartsArt: typeof Highcharts; this.chartOptionsArt;
      this.highchartsArt = Highcharts;
      this.chartOptionsArt = {
        chart: {
          type: 'spline',
        },
        title: {
          text: 'TTP Summary'
        },
        xAxis: {
          title: { Text: 'Month' },
          categories: chartDataCol1,
          crosshair: false,
        },
        yAxis: {
          title: { text: 'TTP Range(Days)' },
          min: 15,
          max: 40,
        },
        style: {
          fontFamily: 'Poppins, Arial, sans-serif'  // Specify a readable font family
        },
        legend: {
          reversed: true,
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'middle',
          borderWidth: 0,
          showInLegend: false
        },
        tooltip: {
          headerFormat: '<span style = "font-size:10px">{category}</span><table>',
          pointFormat: '<tr><td style = "color:{series.color};padding:0">{series.name}: </td>' +
            '<td style = "padding:0"><b>{point.y}</b></td></tr>', footerFormat: '</table>', shared: true, useHTML: true
        },
        series: chartSeriesList
      };
    } catch (e) {
      ngswal("Warning !", e, "warning");
      $("#LoadingImage").hide();
    }
  }
}
